import React from "react";
import { CircularProgress, Box, Paper, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useTranslation } from "react-i18next";
import styles from "../styles/loginContainer.module.css";

const LoginLoading = ({ message, status = "processing", onBack }) => {
  const { t } = useTranslation("login");
  const theme = localStorage.getItem("theme") || "light";

  return (
    <div
      className={styles.container}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100%",
        background: "linear-gradient(-60deg,#d8e2f3,#d8e2f3)",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 5,
          borderRadius: 6,
          width: "100%",
          maxWidth: 480,
          textAlign: "center",
          bgcolor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          animation: "fadeIn 0.6s ease-out",
        }}
      >
        {/* Logo Section */}
        <Box sx={{ mb: 2, transform: "scale(1.1)" }}>
          <img
            height={70}
            src="/NXMap-white-blue.png"
            alt="NXMap Logo"
            style={{ filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.1))" }}
          />
        </Box>

        {/* Text Section */}
        <Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "#2d3c82",
              letterSpacing: "-0.5px",
              mb: 1,
            }}
          >
            {t("Welcome to NXMap®")}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#666",
              maxWidth: "80%",
              margin: "0 auto",
              lineHeight: 1.6,
            }}
          >
            {status === "processing"
              ? message || "Establishing secure connection..."
              : status === "success"
                ? message || "Completed successfully."
              : "Authentication failed."}
          </Typography>
        </Box>

        {/* Status Indicator Section */}
        <Box
          sx={{
            width: "100%",
            mt: 2,
            height: 60,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {status === "processing" ? (
            <React.Fragment>
              <CircularProgress
                size={40}
                thickness={4}
                sx={{
                  color: "#2d3c82",
                  "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
                }}
              />
            </React.Fragment>
          ) : status === "success" ? (
            <CheckCircleOutlineIcon
              sx={{
                width: 48,
                height: 48,
                color: "#1f9d55",
                animation: "popIn 0.35s ease-out",
              }}
            />
          ) : (
            <Box sx={{ width: "100%", animation: "shake 0.4s ease-in-out" }}>
              <button
                onClick={onBack}
                className={styles.loginBtn}
                style={{
                  width: "100%",
                  margin: 0,
                  height: "48px",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: 600,
                  boxShadow: "0 4px 12px rgba(45, 60, 130, 0.2)",
                  transition: "all 0.2s ease",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "translateY(-2px)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "translateY(0)")
                }
              >
                Return to Login
              </button>
            </Box>
          )}
        </Box>

        {/* Footer info */}
        <Typography
          variant="caption"
          sx={{ mt: 3, color: "#999", fontSize: "0.75rem" }}
        >
          Powered by
          <a
            href="https://www.evercomm.com.sg"
            target="_blank"
            rel="noopener noreferrer"
          >
            {theme === "dark" ? (
              <img
                style={{
                  width: "auto",
                  height: "15px",
                  marginLeft: "5px",
                  marginTop: "-7px",
                  marginRight: "5px",
                }}
                src="/evercomm-singapore-white.png"
                alt="Evercomm"
              />
            ) : (
              <img
                style={{
                  width: "auto",
                  height: "15px",
                  marginLeft: "5px",
                  marginTop: "-7px",
                  marginRight: "5px",
                }}
                src="/evercomm-singapore.png"
                alt="Evercomm"
              />
            )}
          </a>
        </Typography>

        <style>{`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes shake {
            0%, 100% { transform: translateX(0); }
            25% { transform: translateX(-5px); }
            75% { transform: translateX(5px); }
          }
          @keyframes popIn {
            from { opacity: 0; transform: scale(0.75); }
            to { opacity: 1; transform: scale(1); }
          }
        `}</style>
      </Paper>
    </div>
  );
};

export default LoginLoading;
